<template>
  <BaseTable
    class="custom-table"
    tableClass="table-bordered"
    hidePagination
  >
    <template #thead>
      <thead>
        <tr>
          <th>{{ $t('apps.billing.label.invoiceno') }}</th>
          <th class="text-center">{{ $t('apps.billing.label.datemonth') }}</th>
          <th class="text-right">{{ $t('apps.billing.label.payamount') }}</th>
        </tr>
      </thead>
    </template>
    <template #tbody>
      <tbody>
        <tr>
          <td>
            <RouterLinkCustom
              :status="{
                color: linkIcon,
                text: linkIconTooltipText,
                type: 'icon'
              }"
            >
              {{ invoice.code }}
            </RouterLinkCustom>
          </td>
          <td class="text-center">
            {{ datePeriodText }}
          </td>
          <td class="text-right">
            {{ getCurrencyWithNumber(numberel(invoice.total, '0,0.00')) }}
          </td>
        </tr>
      </tbody>
    </template>
  </BaseTable>
</template>

<script>
import { BILLING_INVOICE_STATUS } from '../../helpers/enum'

export default {
  props: {
    invoice: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    isPaid () {
      return this.invoice.status === BILLING_INVOICE_STATUS.PAID
    },
    linkIcon () {
      return this.isPaid ? 'success' : 'info'
    },
    linkIconTooltipText () {
      return this.isPaid ? this.$t('apps.billing.status.paid') : this.$t('apps.billing.status.pending')
    },
    datePeriodText () {
      return this.getDateMonthYear(this.moment(this.invoice.dateEnd).subtract(1, 'month').toDate())
    },
  },
}
</script>

<style scoped>
.custom-table >>> td {
  padding: 3px 10px 3px 10px;
  font-size: 14px;
}

.custom-table >>> th {
  padding: 6px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/payment/InvoiceListTable.vue